
import React from 'react';
import { BookOpen, Star, Clock, MapPin } from 'lucide-react';

const TourQuickInfo: React.FC = () => {
  return (
    <div className="bg-[#F5EDE0] py-6 px-4 text-center">
      <div className="container mx-auto max-w-4xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 items-center">
          <div className="flex items-center justify-center md:justify-start gap-2">
            <BookOpen size={22} className="text-[#C46829] shrink-0" aria-hidden="true" />
            <p className="text-[#3E2723] font-montserrat text-sm md:text-base">
              <span className="font-semibold">Led by professional NYC historians and cat enthusiasts</span>, including Peggy Gavan
            </p>
          </div>
          <div className="flex flex-wrap justify-center md:justify-end items-center gap-x-8 gap-y-2">
            <div className="flex items-center">
              <Star size={18} className="text-[#D4AF37] mr-2" aria-hidden="true" />
              <span className="text-[#3E2723] font-montserrat text-sm md:text-base font-semibold">
                98% five-star reviews
              </span>
            </div>
            <div className="flex items-center">
              <Clock size={18} className="text-[#C46829] mr-2" aria-hidden="true" />
              <span className="text-[#3E2723] font-montserrat text-sm md:text-base">
                2-hour tours
              </span>
            </div>
            <div className="flex items-center">
              <MapPin size={18} className="text-[#C46829] mr-2" aria-hidden="true" />
              <span className="text-[#3E2723] font-montserrat text-sm md:text-base">
                Small groups
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourQuickInfo;
